<template>
  <div>
    <draggable-table>
      <el-table
        :show-header="false"
        class="table"
        :data="data"
        stripe
        :empty-text="$t('Events_Select_NoData')"
      >
        <el-table-column>
          <template slot-scope="scope">
            {{ scope.row }}
          </template>
        </el-table-column>

        <el-table-column width="40" align="center">
          <template>
            <i class="el-icon-rank"></i>
          </template>
        </el-table-column>

        <el-table-column width="40" align="center">
          <template slot-scope="scope">
            <i class="el-icon-delete" @click="deleteEvent(scope.$index)"></i>
          </template>
        </el-table-column>
      </el-table>
    </draggable-table>

    <el-button
      class="m-top-20"
      icon="el-icon-circle-plus-outline"
      type="primary"
      plain
      @click="showSelect()"
    >
      {{ $t('Events_Button_Add') }}
    </el-button>

    <el-select
      v-show="selectVisible"
      v-model="newEvent"
      ref="select"
      @visible-change="selectVisibleChange"
      @change="addEvent"
      :loading="selectLoading"
      :placeholder="$t('Events_Select_Placeholder')"
      filterable
      remote
      :remote-method="fetchEventsRemote"
    >
      <el-option
        v-for="(item, index) in events.filter(opt => !data.includes(opt.name))"
        :key="index"
        :label="item.name"
        :value="item.name"
      />
    </el-select>
  </div>
</template>

<script>
import RestApi from '@/core/services/RestApi'
import { projectEndpoint } from '@/core/helpers'
import DraggableTable from '@/common/components/table/DraggableTable'

export default {
  name: 'EventsListDraggable',

  components: { DraggableTable },

  props: {
    value: {
      required: true
    }
  },

  data() {
    return {
      data: [],
      events: [],
      newEvent: null,
      selectVisible: false,
      selectLoading: false,
      search: ''
    }
  },

  created() {
    this.data = this.value || []

    this.fetchEvents()
  },

  computed: {
    eventsEndpoint() {
      let params = { sort: 'title' }

      return projectEndpoint({
        method: 'get',
        url: `events`,
        params: params
      })
    }
  },

  methods: {
    showSelect() {
      this.search = ''
      this.fetchEventsRemote('')
      this.selectVisible = true
      setTimeout(() => {
        this.$refs['select'].focus()
      }, 0)
    },

    selectVisibleChange(visible) {
      if (!visible) {
        this.selectVisible = false
      }
    },

    addEvent(event) {
      this.data.push(event)
      this.newEvent = null
    },

    deleteEvent(index) {
      this.data.splice(index, 1)
    },

    fetchEvents() {
      this.selectLoading = true
      RestApi(this.eventsEndpoint)
        .then(({ data }) => {
          this.events = data
          this.selectLoading = false
        })
        .catch(error => {
          this.selectLoading = false
          this.$message({
            message: error.message,
            type: 'error'
          })
        })
    },

    fetchEventsRemote(query) {
      this.search = query

      let params = { sort: 'title' }

      if (query !== null && query !== '') {
        params.title = query
      }

      RestApi({
        ...this.eventsEndpoint,
        params: params
      })
        .then(({ data }) => {
          this.events = data
        })
        .catch(error => {
          this.$message({
            message: error.message,
            type: 'error'
          })
        })
    }
  },

  watch: {
    data: {
      handler: function(value) {
        this.$emit('input', value)
      },
      deep: true
    }
  }
}
</script>

<style scoped lang="scss">
/deep/ .el-table {
  border-radius: 4px;
  border: 1px solid #dbdee7;
}

/deep/ .el-select input {
  height: 36px;
}
.el-icon-delete {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/modules/events/components/EventsListDraggable.vue